import { Button } from '@mantine/core';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import classes from './banner.module.css';

export default function Banner(props) {
  const {
    title,
    subtitle,
    avatar,
    onClick,
    href,
    target = '_self',
    action,
    buttonProps = {},
    height = 'md',
  } = props;

  let actionElement = null;
  const bannerClasses = clsx(classes.banner, height && classes[height]);

  if (href) {
    actionElement = <Link to={href} target={target}>{action}</Link>;
  } else if (onClick) {
    actionElement = <Button variant="transparent" size="compact-md" onClick={onClick} {...buttonProps}>{action}</Button>;
  }

  return (
    <div className={bannerClasses}>
      <div className={classes.body}>
        {title && <div className={classes.title}>{title}</div>}
        {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
        {actionElement && <div className={classes.action}>{actionElement}</div>}
      </div>
      {avatar && <div className={classes.avatar}>{avatar}</div>}
    </div>
  );
}

Banner.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  avatar: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
  action: PropTypes.string,
  buttonProps: PropTypes.object,
  height: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'full']),
};
